<template>
  <Loader v-if="loading"/>
  <div v-else class="h-full">
    <section class="application-create__header">
      <div class="container-fluid">
        <router-link :to="{
        name: 'ApplicantApplicationsList'
      }" class="button__back">
          <svg class="button__icon icon" viewBox="0 0 24 24" width="24" height="24">
            <use xlink:href="@/assets/v2/img/sprite.svg#chevron__left"></use>
          </svg>{{ $lang.app.BACK }}
        </router-link>
        <div class="flex justify-between">
          <h3 class="application-create__title">{{ $lang.app.APPLICATION }}</h3>
          <div class="flex items-center">
            <router-link v-if="application.payments.length"
                         :to="{name: 'ApplicantApplicationPaymentsDetail'}" class="button button--small mr-4">
              {{ $lang.app.PAYMENT }}: {{ application.paymentStatusTxt }}
            </router-link>
            <div v-if="hasRemarks" class="button__dropdown" v-click-outside="() => showRemarksDropdown = false">
              <button class="button button--small button__icon--right red__lighter"
                      @click="showRemarksDropdown = !showRemarksDropdown">
                {{ $lang.app.REMARKS }}
                <svg class="button__icon icon" viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#chevron__down"></use>
                </svg>
              </button>
              <div class="dropdown__list dropdown__notify__list dropdown__list--right" :class="{'opened': showRemarksDropdown}">
                <div class="dropdown__title space__between">{{ $lang.app.REMARKS }}
<!--                  <div class="counter counter&#45;&#45;red">2</div>-->
                </div>
                <div v-for="comment in remarks" :key="comment.id"
                     class="dropdown__notify__item">
                  <div class="stack__list mb1">
                    <div class="stack__label space__between">
                      <div>{{ $lang.app.REMARK }}</div>
                      <div>{{ $moment(comment.createdAt).format('YYYY-MM-DD HH:mm') }}</div>
                    </div>
                    <div class="stack__value">
                      {{ comment.comment }}
                    </div>
                  </div>
                  <router-link v-if="comment.type === returnTypesVK('AGREEMENT_REMARKS')"
                               @click="showRemarksDropdown = false"
                               :to="{name: 'ApplicantApplicationAgreementDetail', params: {applicationId: application.id}}"
                               class="button button--bordered button__icon--right">
                    {{ $lang.app.EDIT_REMARKS }}
                    <svg class="button__icon icon" viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#arrow__right"></use>
                    </svg>
                  </router-link>
                  <router-link v-if="comment.type === returnTypesVK('DOCUMENTS_REMARKS')" @click="showRemarksDropdown = false"
                               :to="{name: 'ApplicantApplicationDocumentsVersionDetail',
                                      params: { applicationId: application.id, documentsVersionId: application.documentsVersions.at(-1).id}}"
                               class="button button--bordered button__icon--right">
                    {{ $lang.app.EDIT_REMARKS }}
                    <svg class="button__icon icon" viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#arrow__right"></use>
                    </svg>
                  </router-link>
                </div>
                <div v-if="activeDocumentVersion"
                     class="dropdown__notify__item">
                  <div class="stack__list mb1">
                    <div class="stack__label space__between">
                      <div>{{ $lang.app.REMARK }}</div>
<!--                      <div>{{ $moment(comment.createdAt).format('YYYY-MM-DD HH:mm') }}</div>-->
                    </div>
                    <div class="stack__value">
                      {{ $lang.app.DOCUMENT_REMARKS }}
                    </div>
                  </div>
                  <router-link @click="showRemarksDropdown = false"
                               :to="{name: 'ApplicantApplicationDocumentsVersionDetail',
                                      params: { applicationId: application.id, documentsVersionId: activeDocumentVersion.id }}"
                               class="button button--bordered button__icon--right">
                    {{ $lang.app.EDIT_REMARKS }}
                    <svg class="button__icon icon" viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#arrow__right"></use>
                    </svg>
                  </router-link>
                </div>
              </div>
            </div>
            <button v-if="sendableToExpertize"
                    type="button"
                    class="button button--small ml-4"
                    @click="sendToExpertise">
              {{ $lang.app.SEND_TO_EXPERTIZE }}
            </button>
            <button v-if="sendableRemarksToExpertize"
                    type="button"
                    class="button button--small ml-4"
                    @click="sendRemarksToExpertise">
              {{ $lang.app.SEND_REMARKS_TO_EXPERTIZE }}
            </button>
            <button v-if="application.actions.some(action => action.constName === 'APPLICANT_DELETE_ACTION')"
                    type="button"
                    class="button__back ml-4"
                    @click="deleteApplication(application.id)">
              <svg class="icon button__icon" viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
              </svg>
              {{ $lang.app.DELETE }}
            </button>
          </div>
        </div>
      </div>
    </section>
    <section class="application-create__steps">
      <div class="container-fluid">
        <div class="application-create__steps__wrapper mb-3">
          <router-link :to="{
            name: 'ApplicantApplicationMainDetail',
            params: { applicationId: application.id },
          }" class="step__item"
                       :class="{'step__active': ['ApplicantApplicationMainDetail', 'ApplicantApplicationMainEdit'].includes($route.name),
                       'step__filled': application}">
            <span class="step__count">
              <svg v-if="application" viewBox="0 0 16 16" width="16" height="16">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
              </svg>
              <span v-else>1</span>
            </span>
            <span class="step__title">{{ $lang.app.GENERAL_INFORMATION }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>
          <router-link :to="{
            name: 'ApplicantApplicationApplicantDetail',
            params: { applicationId: application.id },
          }" class="step__item"
                       :class="{'step__active': $route.matched.some(item => item.name === 'ApplicantApplicationApplicantDetail'),
                       'step__filled': application?.applicants?.length}">
            <span class="step__count">
              <svg v-if="application?.applicants?.length" viewBox="0 0 16 16" width="16" height="16">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
              </svg>
              <span v-else>2</span>
            </span>
            <span class="step__title">{{ $lang.app.APPLICANT_DATA }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>
          <router-link :to="{
            name: 'ApplicantApplicationCustomerDetail',
            params: { applicationId: application.id },
          }" class="step__item"
                       :class="{'step__active': $route.matched.some(item => item.name === 'ApplicantApplicationCustomerDetail'),
                        'step__filled': isCustomersValid}">
            <span class="step__count">
              <svg v-if="isCustomersValid" viewBox="0 0 16 16" width="16" height="16">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
              </svg>
              <span v-else>3</span>
            </span>
            <span class="step__title">{{ $lang.app.CUSTOMER_DATA }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>
          <router-link :to="{
            name: 'ApplicantApplicationPlannersList',
            params: { applicationId: application.id },
          }" class="step__item" :class="{'step__active': ['ApplicantApplicationPlannersList', 'ApplicantApplicationPlannersCreate', 'ApplicantApplicationPlannersEdit'].includes($route.name),
          'step__filled': application?.projectDevelopers?.length}">
            <span class="step__count">
              <svg v-if="application?.projectDevelopers?.length" viewBox="0 0 16 16" width="16" height="16">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
              </svg>
              <span v-else>4</span>
            </span>
            <span class="step__title">{{ $lang.app.CONSTRUCTOR_DATA }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>

          <router-link v-if="application.documentsVersions?.length" :to="{
            name: 'ApplicantApplicationDocumentsVersionDetail',
            params: { applicationId: application.id, documentsVersionId: application.documentsVersions?.at(-1).id },
          }" class="step__item"
                       :class="{'step__active': $route.matched.some(item => item.name === 'ApplicantApplicationDocumentsVersionDetail'),
                        'step__filled': application.documentsVersions?.every(version => !version.edit || version.documents.every(document => document.signDate))}">
            <span class="step__count">5</span>
            <span class="step__title">{{ $lang.app.DOCUMENTS }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>
          <router-link v-else :to="{
            name: 'ApplicantApplicationDocumentsDetail',
            params: { applicationId: application.id },
          }" class="step__item" :class="{'step__active': ['ApplicantApplicationDocumentsDetail'].includes($route.name),
          'step__filled': isDocumentsValid}">
            <span class="step__count">
              <svg v-if="isDocumentsValid" viewBox="0 0 16 16" width="16" height="16">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
              </svg>
              <span v-else>5</span>
            </span>
            <span class="step__title">{{ $lang.app.DOCUMENTS }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>

          <button v-if="!isCustomersValid" class="step__item" @click="alertFillPreviousSteps">
            <span class="step__count">6</span>
            <span class="step__title">{{ $lang.app.AGREEMENT }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </button>
          <router-link v-else-if="application.agreement" :to="{
            name: 'ApplicantApplicationAgreementDetail',
            params: { applicationId: application.id },
          }" class="step__item" :class="{'step__active': $route.matched.some(item => item.name === 'ApplicantApplicationAgreementDetail'), 'step__filled': isAgreementValid}">
            <span class="step__count">
              <svg v-if="isAgreementValid" viewBox="0 0 16 16" width="16" height="16">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
              </svg>
              <span v-else>6</span>
            </span>
            <span class="step__title">{{ $lang.app.AGREEMENT }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>
          <button v-else-if="!editable" class="step__item" @click="alertPermissionDenied">
            <span class="step__count">6</span>
            <span class="step__title">{{ $lang.app.AGREEMENT }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </button>
          <router-link v-else :to="{
            name: 'ApplicantApplicationAgreementCreate',
            params: { applicationId: application.id },
          }" class="step__item" :class="{'step__active': $route.matched.some(item => item.name === 'ApplicantApplicationAgreementCreate')}">
            <span class="step__count">6</span>
            <span class="step__title">{{ $lang.app.AGREEMENT }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>

          <router-link v-if="application.applicationFile" :to="{
            name: 'ApplicantApplicationAppFileDetail',
            params: { appFileId: application.applicationFile?.id },
          }" class="step__item" :class="{'step__active': $route.matched.some(item => item.name === 'ApplicantApplicationAppFileDetail'), 'step__filled': application?.applicationFile}">
            <span class="step__count">
              <svg v-if="application?.applicationFile" viewBox="0 0 16 16" width="16" height="16">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
              </svg>
              <span v-else>7</span>
            </span>
            <span class="step__title">{{ $lang.app.APPLICATION }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>
          <button v-else-if="!editable" class="step__item" @click="alertPermissionDenied">
            <span class="step__count">7</span>
            <span class="step__title">{{ $lang.app.APPLICATION }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </button>
          <router-link v-else :to="{
            name: 'ApplicantApplicationAppFileCreate',
          }" class="step__item" :class="{'step__active': $route.matched.some(item => item.name === 'ApplicantApplicationAppFileCreate')}">
            <span class="step__count">7</span>
            <span class="step__title">{{ $lang.app.APPLICATION }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>
          <router-link v-if="application.conclusion" :to="{
            name: 'ApplicantApplicationConclusionDetail',
            params: { applicationId: application.id, conclusionId: application.conclusion.id },
          }" class="step__item" :class="{'step__active': ['ApplicantApplicationConclusionDetail'].includes($route.name),
          'step__filled': application?.conclusion}">
            <span class="step__count">
              <svg viewBox="0 0 16 16" width="16" height="16">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__check"></use>
              </svg>
            </span>
            <span class="step__title">{{ $lang.app.CONCLUSION }}</span>
            <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>
          </router-link>
        </div>
      </div>
    </section>
    <router-view :application="application"/>
    <ApplicantApplicationPdfFileModal/>
  </div>
</template>
<script>
import applicationApi from "../../../api/applicant/application";
import {getValueByKey as customerStatusesGetValueByKey} from "../../../helpers/constants/customerStatuses";
import ApplicantApplicationPdfFileModal
  from "../../../components/applicant/application/modals/ApplicantApplicationPdfFileModal.vue";
import {getValueByKey as returnTypesVK} from "../../../helpers/constants/returnTypes";

export default {
  name: 'ApplicationLayout',
  components: {
    ApplicantApplicationPdfFileModal
  },
  data() {
    return {
      loading: true,
      application: null,

      showRemarksDropdown: false,
    }
  },
  computed: {
    editable() {
      return this.application.actions.some(action => action.constName === 'APPLICANT_EDIT_ACTION')
    },
    sendableToExpertize() {
      return this.application?.actions.some(action => action.constName === 'SEND_ACTION')
    },
    sendableRemarksToExpertize() {
      return this.application?.actions.some(action => action.constName === 'REMARKS_SEND_ACTION')
    },
    isCustomersValid() {
      if(!this.application || !this.application.customers.length) {
        return false
      }

      if(!this.application.customers.some(c => c.payer)) {
        return false
      }

      return !this.application.customers.some(c => c.requestStatus !== this.customerStatusesGetValueByKey('CONFIRMED'))
    },
    isDocumentsValid() {
      if(!this.application || !this.application.documents.length) {
        return false
      }

      return !this.application.documents.some(d => d.signDate === null)
    },
    isAgreementValid() {
      if(!this.application || !this.application.agreement) {
        return false
      }

      return !this.application.agreement.agreementSigners.some(s => s.signDate === null)
    },
    hasAnswer() {
      return this.application && (
          this.application.comments.length ||
          this.application.payments.length ||
          this.application.conclusion ||
          this.application.documentsVersions?.length
      )
    },
    hasRemarks() {
        return this.application && (
            this.application.documentsVersions?.some(version => version.edit)
            || this.application.comments.some(comment => ([this.returnTypesVK('RETURN'), this.returnTypesVK('REFUSE')].includes(comment.type) && !comment.fixed))
            || (this.application.comments.some(comment => (comment.type === this.returnTypesVK('AGREEMENT_REMARKS') && !comment.fixed)) && !this.application.appicationFile)
        )
    },
    activeDocumentVersion() {
      return this.application.documentsVersions?.find(version => version.edit)
    },
    remarks() {
      return this.application.comments.filter(item => !item.fixed)
    }
  },
  created() {
    this.fetchApplication();
  },
  watch: {
    $route() {
      this.fetchApplication();
    },
  },
  beforeMount() {
    this.$emitter.on('refresh-application', () => {
      this.fetchApplication()
    })
  },
  beforeUnmount() {
    this.$emitter.off('refresh-application')
  },
  methods: {
    customerStatusesGetValueByKey,
    returnTypesVK,
    fetchApplication() {
      if (this.$route.params.applicationId) {
        applicationApi.getApplication(this.$route.params.applicationId)
            .then(({ data }) => {
              this.application = data;
            })
            .catch((error) => {
              console.log(error);
            }).finally(() => {
          this.loading = false
        });
      } else {
        this.loading = false
      }
    },
    alertFillPreviousSteps() {
      alert(this.$lang.app.FIRST_FILL_PREVIOUS_STEPS + '!');
    },
    alertPermissionDenied() {
      alert(this.$lang.app.PERMISSION_DENIED + '!');
    },
    sendToExpertise() {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .sendToExpertise(this.application.id)
          .then(() => {
            this.$snotify.success(this.$lang.app.APPLICATION_SENT_TO_EXPERTIZE);
            this.fetchApplication()
          })
          .catch((error) => {
            this.$snotify.error(error);
          }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      });
    },
    sendRemarksToExpertise() {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .sendRemarksToExpertise(this.application.id)
          .then(() => {
            this.$snotify.success(this.$lang.app.APPLICATION_SENT_TO_EXPERTIZE);
            this.fetchApplication()
          })
          .catch((error) => {
            this.$snotify.error(error);
          }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      });
    },
    deleteApplication(applicationId) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteApplication(applicationId)
              .then(() => {
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
                this.$router.push({name: 'ApplicantApplicationsList'})
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    }
  }
}
</script>